var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCubeShape04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9367 35.7089L40.6983 29.8564L34.3798 0.80375L30.618 6.65548L36.9367 35.7089Z",
    fill: "url(#paint0_linear_173_64)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9367 35.7089L40.6983 29.8564L34.3798 0.80375L30.618 6.65548L36.9367 35.7089Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56531 12.974L5.32629 7.12243L34.3797 0.803738L30.6179 6.65547L1.56531 12.974Z",
    fill: "url(#paint1_linear_173_64)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56531 12.974L5.32629 7.12243L34.3797 0.803738L30.6179 6.65547L1.56531 12.974Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9372 35.7079L30.6187 6.6553L1.56603 12.9738L7.88455 42.0265L36.9372 35.7079Z",
    fill: "url(#paint2_linear_173_64)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_173_64",
    x1: 38.2132,
    y1: 14.2807,
    x2: 29.2318,
    y2: 28.2555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C21C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73174C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_173_64",
    x1: 11.3878,
    y1: 2.65733,
    x2: 29.6616,
    y2: 14.4025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C21C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73174C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_173_64",
    x1: 8.93457,
    y1: 26.5843,
    x2: 32.7944,
    y2: 21.3951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C21C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73174C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubeShape04);
export default __webpack_public_path__ + "static/media/cubeShape04.ada5f5d05992a61174ad655b99bdbbd4.svg";
export { ForwardRef as ReactComponent };